import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, AlertCircle } from "lucide-react";

export function ConfirmSubscriptionPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    if (!token) { setState({ status: "error", msg: "Missing token" }); return; }
    api.get(`/subscribers/confirm?token=${encodeURIComponent(token)}`)
      .then((r) => setState({ status: "ok", email: r.data.email }))
      .catch((e) => setState({ status: "error", msg: e?.response?.data?.detail || "Could not confirm" }));
  }, [token]);

  return (
    <div className="container-page py-24 text-center" data-testid="confirm-subscription-page">
      {state.status === "loading" && <p className="text-muted-foreground">Confirming…</p>}
      {state.status === "ok" && (
        <>
          <CheckCircle2 className="mx-auto h-14 w-14 text-success" />
          <h1 className="mt-6 font-display text-4xl font-bold text-primary">You're subscribed</h1>
          <p className="mt-3 text-foreground/70">We confirmed <strong>{state.email}</strong>. Expect a weekly note from us.</p>
          <Link to="/" className="btn-primary mt-8 inline-flex">Back to home</Link>
        </>
      )}
      {state.status === "error" && (
        <>
          <AlertCircle className="mx-auto h-14 w-14 text-destructive" />
          <h1 className="mt-6 font-display text-4xl font-bold text-primary">We couldn't confirm</h1>
          <p className="mt-3 text-foreground/70">{state.msg}</p>
        </>
      )}
    </div>
  );
}

export function UnsubscribePage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    if (!token) { setState({ status: "error", msg: "Missing token" }); return; }
    api.get(`/subscribers/unsubscribe?token=${encodeURIComponent(token)}`)
      .then((r) => setState({ status: "ok", email: r.data.email }))
      .catch((e) => setState({ status: "error", msg: e?.response?.data?.detail || "Could not unsubscribe" }));
  }, [token]);

  return (
    <div className="container-page py-24 text-center" data-testid="unsubscribe-page">
      {state.status === "loading" && <p className="text-muted-foreground">Processing…</p>}
      {state.status === "ok" && (
        <>
          <CheckCircle2 className="mx-auto h-14 w-14 text-primary-light" />
          <h1 className="mt-6 font-display text-4xl font-bold text-primary">You've been unsubscribed</h1>
          <p className="mt-3 text-foreground/70">We'll stop sending email to <strong>{state.email}</strong>. Sorry to see you go.</p>
          <p className="mt-6 text-sm text-muted-foreground">Want updates with a different address? <Link to="/" className="text-accent-dark font-semibold">Subscribe again</Link>.</p>
        </>
      )}
      {state.status === "error" && (
        <>
          <AlertCircle className="mx-auto h-14 w-14 text-destructive" />
          <h1 className="mt-6 font-display text-4xl font-bold text-primary">Link expired</h1>
          <p className="mt-3 text-foreground/70">{state.msg}</p>
        </>
      )}
    </div>
  );
}
